export default "__VITE_ASSET__UVId2RoK__"